import utils from './../../plugins/utility'

var d = new Date(),
    nextDate = new Date()
nextDate.setDate(nextDate.getDate() - 30)

const state = {
    fromDate: {
        day: nextDate.getDate(),
        month: utils.getMonthName(nextDate.getMonth()),
        year: nextDate.getFullYear()
    },
    toDate: {
        day: d.getDate(),
        month: utils.getMonthName(d.getMonth()),
        year: d.getFullYear()  
    },
    showEmailType: {
        show_blank: true,
        show_unused: false,
        show_used: false,
        show_junk: false,
        show_copy: false
    },
    hideMarkedRead: false,
    flags: {
        c: false,
        en: false,
        n: false,
        rl: false,
        tc: false,
        tl: false,
        id: false,
        pt: false,
        pn: false,
        ae: false,
        po: false,
        hr: false,
        re: false,
    },
    panelist: '',
    state: '',
    country: 'US',
    businessOwner: '-1',
    partition: '',
    isFromSearch: false,
    searchQuery: '',
    searchId: 0,
    searchBy: {
        id: false,
        subject: true,
        body: false,
        sender_name: false,
        sender_email: false,
    },
    type_panelist: ''
}

export default state
